
import React, { useState } from 'react';
import { Button, TextField, Box } from '@mui/material';
import Modal from 'react-bootstrap/Modal';
import { writeTransactionFromWallet } from "../extensionMethods/app";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';


const GiniRequest = ({ goBack, merchantId }) => {  // Add goBack prop
  const [modalShow, setModalShow] = useState(false);

  const handleGini = () => {
    // Check if merchantId is empty
    // if (!merchantId) {
    //   setMerchantIdError(true);
    //   return; // Prevent sending the email if validation fails
    // } else {
    //   setMerchantIdError(false);
    // }

    // Pre-fill the email with user data
    const emailBody = `
      Kalp Wallet ID: ${merchantId}
    `;

    // Create a mailto link with subject and body
    const mailToLink = `mailto:request.cbdc@bimtech.ac.in?subject=Request for GINI&body=${encodeURIComponent(emailBody)}`;

    // Open default email client (Google Mail will be prompted if set as the default)
    window.location.href = mailToLink;
  };
  


  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      padding: '20px',
    }}>
      {/* Back Button */}
      <Button
        onClick={goBack}  // Call goBack on click
        startIcon={<ArrowBackIcon />}
        sx={{
          alignSelf: 'flex-start',
          marginBottom: '20px',
          textTransform: 'none',
        }}
      >
        Back
      </Button>

      <TextField
        placeholder="Enter User's Address"
        variant="outlined"
        value={merchantId}
        fullWidth
        sx={{
          backgroundColor: 'white',
          borderRadius: '8px',
          marginBottom: '20px',
          maxWidth: '400px',
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            '& fieldset': {
              borderColor: '#E0E0E0',
            },
            '&:hover fieldset': {
              borderColor: '#E0E0E0',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#1976D2',
            },
          },
        }}
        InputProps={{ 
          readOnly: true, 
          sx: { borderRadius: '12px', height: '50px' }
        }}
      />

       {/* Whitelist User Button */}
       <Button
        variant="contained"
        onClick={handleGini}
        sx={{
          marginBottom: '10px',
          backgroundColor: '#0055FF',
          borderRadius: '8px',
          height: '45px',
          width: '100%', // Ensures button width matches TextField
          maxWidth: '400px',
          textTransform: 'none',
          fontSize: '16px',
          fontWeight: 'bold',
          '&:hover': {
            backgroundColor: '#0044CC',
          },
        }}
      >
        Send Gini
      </Button>
    </Box>
  );
};

export default GiniRequest;
